<template>
    <hypothetical :mwc-id="getMwcIdForChild('hypo')" :languageId="languageId" @languageChanged="handleLanguageChanged"></hypothetical>
</template>

<script>
import Hypothetical from "./Hypothetical";
import MwcVueHelperMixin from "mwc-vue-component-helper";
import MwcTokenSourceMixin from "./mixins/MwcTokenSourceMixin";
import store from "./store";
import * as types from "./store/mutation-types";
import { getOrigin, setLocation } from "./util";

export function responseHandler(response) {
    if (response.status === 401) {
        store.commit(`auth/${types.SET_TOKEN_EXPIRED_STATUS}`, true);
        return Promise.reject(response);
    } else if (response.headers.get("content-type").indexOf("application/json") > -1) {
        store.commit(`auth/${types.SET_TOKEN_EXPIRED_STATUS}`, false);
        return response.json();
    } else {
        store.commit(`auth/${types.SET_TOKEN_EXPIRED_STATUS}`, false);
        return response;
    }
}

export function responseErrorHandler(response) {
    if (response.status === 401) {
        const originUrl = getOrigin();
        const loginUrl = `${originUrl}/login`;
        setLocation(loginUrl);
    }
    return Promise.reject(response);
}

let tokenSourceOptions = {
    responseHandlers: [
        {
            response: responseHandler
        },
        {
            responseError: responseErrorHandler
        }
    ],
    refreshToken(callback) {
        callback(null, "");
    },
    verifyToken: false,
    verifyResponse: false
};

if (window.AppSettings && window.AppSettings._csrfToken) {
    tokenSourceOptions = {
        requestHeaders: {
            [`X-CSRF-TOKEN`]: window.AppSettings._csrfToken
        },
        ...tokenSourceOptions
    };
}

export default {
    name: "app",
    components: {
        Hypothetical
    },
    data() {
        return {
            languageId: "en-US"
        };
    },
    mixins: [MwcVueHelperMixin, MwcTokenSourceMixin],
    beforeCreate() {
        window.mwc.configuration.setAppConfig({
            settings: {
                tokenSourceOptions: tokenSourceOptions
            },
            components: {
                "mwc-hypo-app": {
                    components: {
                        hypo: {
                            components: {
                                "mwc-choose-type": {
                                    components: {
                                        header: {
                                            settings: {
                                                showSignOut: true,
                                                showBanner: true
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        });
    },
    methods: {
        handleLanguageChanged(languageId) {
            this.languageId = languageId;
        }
    },
    watch: {
        languageId: {
            handler: function() {
                window.mwc.configuration.setAppConfig({
                    settings: {
                        languageId: this.languageId
                    }
                });
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss">
@import "~@mds/typography";
// support webfontloader to avoid FOUT(Flash of Unstyled Text)
.wf-loading body {
    visibility: hidden;
}
.wf-active body .wf-inactive body {
    visibility: visible;
    font-family: $mds-typography-font-family-sans-serif;
}

html,
body {
    margin: 0px;
    padding: 0px;
    height: 100%;
}

body {
    overflow: hidden;
}
</style>

<style lang="scss" scoped>
@import "~@mds/typography";
#app {
    font-family: $mds-typography-font-family-sans-serif;
    font-weight: $mds-typography-font-weight-light;
    width: 100%;
    height: 100%;
}
</style>
